import { isMobile } from './isMobile';

const APP_VERSION = '0.0.1';

export const expandTgApp = async () => {
  const Telegram = window.Telegram;

  // для отображения приложения на весь экран в браузере
  // document.body.classList.add('full-screen');

  const checkMobile = isMobile();

  if (Telegram && Telegram.WebApp) {
    Telegram.WebApp.ready(); // Уведомляем Telegram, что приложение готово

    await Telegram.WebApp.expand(); // Разворачиваем приложение на весь экран

    Telegram.WebApp.disableVerticalSwipes(); // Отключаем вертикальные свайпы

    try {
      Telegram.WebApp.setHeaderColor('#000');
      Telegram.WebApp.setBackgroundColor('#223434');
    } catch (err) {
      console.warn('Ошибка при установке цветов заголовка:', err);
    }

    if (checkMobile) {
      enableTelegramFullscreen();
    }
  }
};

export function checkTgApp() {
  // Инструмент для очистки локального хранилища пользователя
  /**
   * В localStorage храним условную версию приложения, и если она изменилась
   * полностью очищаем localStorage и обновляем страницу
   */
  const localVersion = localStorage.getItem('ver');

  if (localVersion && localVersion !== APP_VERSION) {
    localStorage.clear();
    document.location.reload();
  }
  localStorage.setItem('ver', APP_VERSION);
}

export function getTgUserData() {
  const Telegram = window.Telegram;

  if (!Telegram || !Telegram.WebApp || !Telegram.WebApp.initData) {
    if (import.meta.env.DEV) {
      const initData = import.meta.env.VITE_INIT_DATA;
      const userName = import.meta.env.VITE_USER_NAME;

      return { initData, userName };
    }
    return undefined;
  }

  const webApp = Telegram.WebApp;
  const user = webApp.initDataUnsafe.user;

  return {
    initData: webApp.initData,
    userName: user?.username ?? '',
    user,
  };
}

export const enableTelegramFullscreen = () => {
  const Telegram = window.Telegram;

  if (parseFloat(Telegram?.WebApp?.version ?? '0') >= 8.0) {
    Telegram?.WebApp?.requestFullscreen?.();
    document.body.classList.add('full-screen');
  }
};

export const isFullScreen = () => {
  return document.body.classList.contains('full-screen');
};
